module.exports = __webpack_public_path__ + "static/img/point-bg@w.c7309d5.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/premium-food-market/point-bg@w.png
// module id = Dx0n
// module chunks = 0